import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { POSPlan } from 'models/productsV3.model'

const initialState: POSPlan[] = []

const plansSlice = createSlice({
  name: 'plansV3',
  initialState,
  reducers: {
    removePlan: (state: POSPlan[], action: PayloadAction<string>) => {
      const { payload } = action
      if (payload) {
        return state.filter((plan) => plan.id + '' !== payload)
      }
    },
    addOrUpdatePlan: (state: POSPlan[], action: PayloadAction<POSPlan>) => {
      const { id, name, quantity } = action.payload
      const planToUpdate = state.find((plan) => plan.id === id)
      if (planToUpdate) {
        planToUpdate.quantity = quantity
      } else {
        state.push({ id, name, quantity })
      }
    },
    clearPlans: () => {
      return initialState
    },
  },
})

export const { removePlan, addOrUpdatePlan, clearPlans } = plansSlice.actions

export default plansSlice.reducer
